<!-- eslint-disable no-dupe-keys -->
<template>
  <sc-table-select
    :class="{ 'custom-org-el-select-close': orgcodevalue.length <= 1 }"
    placeholder="---请选择---"
    ref="tableselect"
    v-model="orgcodevalue"
    style="width: 300px"
    :pageId="pageId"
    :userCode="userCode"
    :purviewType="purviewType"
    :attrList="attrList"
    :valueList="valueList"
    :queryList="queryList"
    :orderList="orderList"
    :table-width="640"
    :multiple="multiple"
    selectType="org"
    collapse-tags
    collapse-tags-tooltip
    :props="props"
    :selectKeyValue="selectKeyValue"
    @change="change"
    @remove-tag="removeTag"
  >
    <!-- collapse-tags ollapse-tags-tooltip -->
    <template #header="{}">
      <el-form :inline="true">
        <el-row :gutter="5"
          ><el-col :span="5">
            <el-input
              v-model="queryList.OrgCode"
              placeholder="请输入编码"
              style="width: 125px"
              :disabled="viewStore"
            ></el-input></el-col
          ><el-col :span="5">
            <el-input
              v-model="queryList.OrgName"
              placeholder="请输入名称"
              style="width: 125px"
            ></el-input> </el-col
          ><el-col :span="5"
            ><el-select
              v-model="queryList.TypeCode"
              placeholder="请选择类型"
              style="width: 125px"
              clearable
              :teleported="false"
            >
              <el-option label="---请选择---" value=""></el-option>
              <el-option label="直营店" value="01"></el-option>
              <el-option
                label="加盟店"
                value="02"
              ></el-option> </el-select></el-col
          ><el-col :span="5">
            <el-select
              v-model="queryList.State"
              placeholder="请选择状态"
              clearable
              :teleported="false"
              style="width: 125px"
            >
              <el-option label="---请选择状态---" value="" />
              <el-option label="禁用" value="0" />
              <el-option label="启用" value="1" /> </el-select></el-col
          ><el-col :span="4">
            <el-button type="primary" @click="$refs.tableselect.getData()"
              >查询</el-button
            ></el-col
          ></el-row
        >
      </el-form>
    </template>
    <el-table-column
      prop="OrgCode"
      label="机构编码"
      width="100"
    ></el-table-column>
    <el-table-column
      prop="OrgName"
      label="机构名称"
      width="200"
    ></el-table-column>
    <el-table-column
      prop="ParentName"
      label="父级"
      width="150"
    ></el-table-column>
    <el-table-column
      prop="OrgTypeName"
      label="类型"
      width="120"
    ></el-table-column>
    <el-table-column prop="State" label="状态" width="100"></el-table-column>
  </sc-table-select>
</template>

<script>
import tool from "@/utils/tool";
import bus from "@/utils/mitt";
export default {
  name: "orgselect",
  props: {
    pageId: {
      type: String,
      default: "",
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    userCode: {
      type: String,
      default: "super",
    },
    selectKeyValue: {
      type: String,
      default: "Code",
    },
    IsStore: {
      type: Boolean,
      default: false,
    },
    BrandCode: {
      type: String,
      default: "",
    },
    IsDefault: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      viewStore: false,
      hideClearBtn: true,
      attrList: {
        //Name: "Organize",
        Name: "PageOrg",
        UseDistinct: true,
        OrgCode: "",
        UseBackUp: false,
        UseGroup: false,
      },
      valueList: {
				OrgCode: "OrgCode",
				OrgName: "OrgName",
				//ParentName: "ParentName",
				OrgType: "OrgType",
				//OrgTypeName: "OrgTypeName",
				//State: "State",
				//PageId: "",
				//UserCode: "",
			},
			queryList: {
				OrgCode: "",
				OrgName: "",
				OrgTypeCode: "",
				Visible: "1",
				// InLocal:"0",
				//State: "",
				PageId: this.pageId,
				UserCode: this.userCode,
				purviewType: "super",
			},
      //apiObj: this.$API.demo.page,
      params: {
        name: "demoName",
      },
      orgcodevalue: [],
      props: {
        label: "OrgName",
        value: "OrgCode",
        keyword: "keyword",
      },
      formatType(row, column) {
        // eslint-disable-next-line no-debugger
        ////debugger;
        console.log(row, column);
        switch (row.TypeCode) {
          case "01":
            return "直营店";
          case "02":
            return "加盟店";
          default:
            return "";
        }
      },
      lastOrgVal: [],
    };
  },
  computed: {},
  created() {
 
  },
  mounted() {
  
  },
  methods: {
    //值变化
    change(val, oldvalue) {
      console.log(val);
      
      // eslint-disable-next-line no-debugger
      //debugger;
      let userInfo = tool.data.get("USER_INFO");
    
      let userCode = userInfo.userCode;
      if (userCode == "admin" || userCode == "super")
       
        this.returnFather(val)
      else {
        if (Array.isArray(val)) {
          if (val.length == 0) {
            this.$alert("请选择要操作的机构", "提示", {
              type: "warn",
            });
         
             this.returnFather([])
          } else this.returnFather(val) 
        } else {
          if (val) {
            this.returnFather(val)
          }
        }
      }
      //this.$message("change事件，返回详情查看控制台1");
    },
    async returnFather(rowData){ // 回复父级 门店信息和用户权限
      	let orgCodeList = "";
				let orgNameList = "";
				if (rowData && rowData.length > 0) {
					if (rowData.length == 1) {
						orgCodeList = rowData[0].OrgCode;
						orgNameList = rowData[0].OrgName;
					} else {
						for (let i = 0; i < rowData.length; i++) {
							orgCodeList += rowData[i].OrgCode + ",";
							orgNameList += rowData[i].OrgName + ";";
						}
					}
				}
      let permissionState = await this.$authUtil.initPurview(orgCodeList,this.pageId,this.$API)
        // orgCodeList 选中房台code的字符串
        // orgNameList 选中房台name的字符串
        // permissionState 返回的权限
        // rowData      原未处理的返回参数
      this.$emit("fatherMethod", orgCodeList,orgNameList,permissionState,rowData)
    }

  },
};
</script>

<style></style>
